import { MeshBasicMaterial, Mesh, PlaneGeometry } from "three";
import { VBase } from "./VBase";

const defaultOptions = {
  map: null,
  color: 0x676767,
  opacity: 0.5,
  width: 2,
  height: 1,
  radius: 0.1,
  dragable: true,
  disabledColor: 0xc8c8c8,
};

/* 
  使用案例

     const container = this.uiLib.createContainer({
        dragable: true,
      });
      this.uiLib.addUIToScene(container);

      // 往容器中添加UI对象
      const btn = this.uiLib.createBtn({
        width: 0.5,
        height: 0.2,
        textSize: 0.05,
        textColor: 0x00ffff,
        text: "确定",
        stateChangeColor: {
          normal: "#ffffff",
          hover: "#af3546",
          click: "#C8C8C8",
        },
      });
      container.add(btn);
      // 需要交互的对象需要往前一点避免射线检测被容器遮挡
      btn.position.z = 0.001;
*/

export class VContainer extends VBase {
  /**
   * 创建UI矩形容器
   * options:
   * {
   *      map: 背景贴图，不是贴图地址，默认为null
   *      color: 容器颜色。默认为 0x676767
   *      opacity: 容器背景透明度，默认为0.5
   *      width: 容器宽度，默认为 2
   *      height: 容器高度，默认为 1
   *      radius: 圆角半径，设为0则是矩形，默认为0.1
   *      dragable : 是否允许拖拽移动，默认为true
   *      priority: 优先级，默认为2，值越小越靠前
   *      renderOrder: 渲染顺序，默认为99899
   *      disabledColor:  ui对象禁用颜色，默认为 0xC8C8C8
   * }
   * @param {*} options
   */
  constructor(options, vuiLib) {
    if (!options) options = {};

    const tempOptions = {
      priority: options.priority !== undefined ? options.priority : 2,
      renderOrder:
        options.renderOrder !== undefined ? options.renderOrder : 99899,
      map: options.map ? options.map : defaultOptions.map,
      color: options.color !== undefined ? options.color : defaultOptions.color,
      opacity:
        options.opacity !== undefined
          ? options.opacity
          : defaultOptions.opacity,
      width: options.width !== undefined ? options.width : defaultOptions.width,
      dragable:
        options.dragable !== undefined
          ? options.dragable
          : defaultOptions.dragable,
      height:
        options.height !== undefined ? options.height : defaultOptions.height,
      radius:
        options.radius !== undefined ? options.radius : defaultOptions.radius,
      disabledColor:
        options.disabledColor !== undefined
          ? options.disabledColor
          : defaultOptions.disabledColor,
    };

    super(tempOptions, vuiLib);
    this._vType = "VContainer";

    this._otherProps = {
      dragable: tempOptions.dragable,
    };

    this.name = "VContainer";

    this.mask = new Mesh(
      new PlaneGeometry(8, 8),
      new MeshBasicMaterial({ transparent: true, opacity: 0.001 })
    );
    this.mask.material.visible = false;
  }

  clear() {
    super.clear();
    this.mask.geometry.dispose();
    this.mask.material.dispose();
  }

  /**
   * 鼠标或手柄扳机键按下事件
   */
  onSelectStart(worldPos) {
    if (!this._baseProps.enabled) return;

    this.add(this.mask);
    this.isDraging = true;

    this.srcClickPos = this.parent.worldToLocal(worldPos);
    this.srcClickPos.z = 0;

    this.srcLocalPos = this.position.clone();

    this.offset = this.srcLocalPos.sub(this.srcClickPos);
  }

  /**
   * 鼠标或手柄扳机键松开事件
   */
  onSelectEnd(obj) {
    if (!this._baseProps || !this._baseProps.enabled) return;
    this.mask.removeFromParent();
    this.isDraging = false;

    super.onSelectEnd();
  }

  /**
   * 拖拽移动过程中
   * @param {*} worldPos
   * @returns
   */
  onMoving(worldPos) {
    if (!this._baseProps.enabled) return;
    if (!this.isDraging || !worldPos || !this._otherProps.dragable) return;

    let clickPos = this.parent.worldToLocal(worldPos);
    clickPos.z = 0;

    this.position.copy(clickPos.clone().add(this.offset));
  }
}
